import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { sendLoginOtp, verifyLoginOtp } from "../../services/businessOwnerService";
const RESEND_SECONDS = 60;

function BusinessOwnerLogin() {
  const navigate = useNavigate();

  const [step,    setStep]    = useState("phone"); // "phone" | "otp"
  const [phone,   setPhone]   = useState("");
  const [otp,     setOtp]     = useState("");
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");
  const [info,    setInfo]    = useState("");
  const [countdown, setCountdown] = useState(0);

  // Countdown timer for resend
  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  // Redirect if already logged in
  useEffect(() => {
    if (localStorage.getItem("businessOwnerToken")) {
      navigate("/business-owner/edit", { replace: true });
    }
  }, [navigate]);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setInfo("");

    const trimmed = phone.trim();
    if (!trimmed) { setError("Please enter your phone number"); return; }

    setLoading(true);
    try {
      await sendLoginOtp(trimmed);
      setStep("otp");
      setInfo("OTP sent to your mobile number.");
      setCountdown(RESEND_SECONDS);
    } catch (err) {
      setError(err?.response?.data?.msg || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setError("");

    if (!otp.trim() || otp.trim().length !== 6) {
      setError("Enter the 6-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const data = await verifyLoginOtp(phone.trim(), otp.trim());
      localStorage.setItem("businessOwnerToken", data.token);
      localStorage.setItem("businessOwnerName", data.businessName || "");
      navigate("/business-owner/edit", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.msg || "Invalid or expired OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError("");
    setInfo("");
    setLoading(true);
    try {
      await sendLoginOtp(phone.trim());
      setOtp("");
      setInfo("OTP resent successfully.");
      setCountdown(RESEND_SECONDS);
    } catch (err) {
      setError(err?.response?.data?.msg || "Failed to resend OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="owner-page">
      <div className="owner-card">
        <h2>Business Owner Login</h2>
        <p className="owner-subtitle">
          Enter the phone number registered with your business listing.
        </p>

        {error && <div className="owner-error">{error}</div>}
        {info  && <div className="owner-info">{info}</div>}

        {step === "phone" ? (
          <form onSubmit={handleSendOtp}>
            <div className="owner-form-group">
              <label htmlFor="phone">Mobile Number</label>
              <input
                id="phone"
                type="tel"
                placeholder="Enter your 10-digit mobile number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                maxLength={13}
                autoFocus
              />
            </div>
            <button type="submit" className="owner-btn-primary" disabled={loading}>
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </form>

        ) : (
          <form onSubmit={handleVerifyOtp}>
            <div className="owner-form-group">
              <label htmlFor="otp">Enter OTP</label>
              <div className="otp-input-row">
                <input
                  id="otp"
                  type="text"
                  inputMode="numeric"
                  placeholder="— — — — — —"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                  maxLength={6}
                  autoFocus
                />
              </div>
            </div>

            <button type="submit" className="owner-btn-primary" disabled={loading}>
              {loading ? "Verifying..." : "Verify OTP & Login"}
            </button>

            <div className="resend-row">
              {countdown > 0 ? (
                <span>Resend OTP in {countdown}s</span>
              ) : (
                <button
                  type="button"
                  className="resend-link"
                  onClick={handleResend}
                  disabled={loading}
                >
                  Resend OTP
                </button>
              )}
            </div>

            <div style={{ textAlign: "center", marginTop: 16 }}>
              <button
                type="button"
                className="owner-btn-secondary"
                onClick={() => { setStep("phone"); setOtp(""); setError(""); setInfo(""); }}
              >
                Change Number
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default BusinessOwnerLogin;
